import currencyList from '@akerolabs/akero-constants/src/constants/currencies'

/**
 * @returns {String}
 * @description Returns currency symbol based on code string
 */
export function currencyCodeToSymbol(str) {
  return currencyList[str]?.symbol
}
